
const _lang = document.documentElement.lang || 'de';
const _from = _lang === 'pl' ? 'od' : 'ab';
const _to   = _lang === 'pl' ? 'do' : 'bis';

// Generic filter setup function
export function setupFilter(config) {
    const toggle = document.querySelector(config.toggleSelector);
    const dropdown = document.querySelector(config.dropdownSelector);
    const minInput = document.querySelector(config.minInputSelector);
    const maxInput = document.querySelector(config.maxInputSelector);
    const hiddenInput = document.querySelector(config.hiddenInputSelector);
    const displayText = document.querySelector(config.displayTextSelector);

    if (!hiddenInput) return;

    // Prefer the server-rendered (already translated) text; fall back to config
    const defaultText = (displayText && displayText.textContent.trim()) || config.defaultText || '';

    // Parse current value and populate inputs
    function parseCurrentValue() {
        const currentValue = hiddenInput.value;
        if (currentValue) {
            // Parse formats like "30-100", "100", "0-100", "ab-100", "bis-100"
            if (currentValue.startsWith('ab-')) {
                // ab-100 (min-only)
                const val = currentValue.substring(3);
                minInput.value = config.divisor ? val / config.divisor : val;
                maxInput.value = '';
            } else if (currentValue.startsWith('bis-')) {
                // bis-100 (max-only)
                const val = currentValue.substring(4);
                minInput.value = '';
                maxInput.value = config.divisor ? val / config.divisor : val;
            } else if (currentValue.includes('-') && !currentValue.startsWith('ab-') && !currentValue.startsWith('bis-')) {
                // 30-100 (range)
                const parts = currentValue.split('-');
                const minVal = parts[0] === '0' ? '' : parts[0];
                const maxVal = parts[1];
                // Apply divisor for display (e.g., price/1000)
                minInput.value = minVal ? (config.divisor ? minVal / config.divisor : minVal) : '';
                maxInput.value = maxVal ? (config.divisor ? maxVal / config.divisor : maxVal) : '';
            } else {
                // Plain number like "100" - treat as min-only (consistent with backend)
                const val = config.divisor ? currentValue / config.divisor : currentValue;
                minInput.value = val;
                maxInput.value = '';
            }
        }
    }

    // Update display text based on current values
    function updateDisplayText() {
        const minVal = minInput.value;
        const maxVal = maxInput.value;

        var minEncoded = '';
        var maxEncoded = '';
        if (minVal){
            var minInt = parseInt(minVal);
            if (minInt < 10 * config.multiplier)
                minInt = minInt * config.multiplier;
            minEncoded = (minInt).toLocaleString('de-DE');
        }
        if (maxVal){
            var maxInt = parseInt(maxVal);
            if (maxInt < 10 * config.multiplier)
                maxInt = maxInt * config.multiplier;
            maxEncoded = (maxInt).toLocaleString('de-DE');
        }

        if (minVal && maxVal) {
            displayText.textContent = `${minEncoded}-${maxEncoded} ${config.unit}`;
        } else if (minVal) {
            displayText.textContent = `${_from} ${minEncoded} ${config.unit}`;
        } else if (maxVal) {
            displayText.textContent = `${_to} ${maxEncoded} ${config.unit}`;
        } else {
            displayText.textContent = defaultText;
        }

        const encodedValue = encodeValue();
        hiddenInput.value = encodedValue;
    }

    // Encode values as string
    function encodeValue() {
        const minVal = minInput.value;
        const maxVal = maxInput.value;

        // Apply multiplier for storage (e.g., price*1000)
        const minEncoded = minVal ? (minVal * config.multiplier) : '';
        const maxEncoded = maxVal ? (maxVal * config.multiplier) : '';

        if (minEncoded && maxEncoded) {
            return `${minEncoded}-${maxEncoded}`;
        } else if (minEncoded) {
            return `ab-${minEncoded}`;
        } else if (maxEncoded) {
            return `bis-${maxEncoded}`;
        } else {
            return '';
        }
    }

    // Initialize
    parseCurrentValue();
    updateDisplayText();

    // Toggle dropdown
    toggle.addEventListener('click', function (e) {
        e.preventDefault();
        dropdown.classList.toggle('show');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.remove('show');
        }
    });

    // Update display text when inputs change
    minInput.addEventListener('input', updateDisplayText);
    maxInput.addEventListener('input', updateDisplayText);

    // Prevent dropdown from closing when clicking inside
    dropdown.addEventListener('click', function (e) {
        e.stopPropagation();
    });
}


export function setupCityFilter() {
    const cityToggle = document.querySelector('.city-dropdown-toggle');
    const cityDropdown = document.querySelector('.city-dropdown-menu');
    const cityHiddenInput = document.querySelector('#city-hidden-input');
    const cityDisplayText = document.querySelector('.city-display-text');
    const cityOptions = document.querySelectorAll('.city-option');

    if (!cityHiddenInput) return;

    const defaultCityText = (cityDisplayText && cityDisplayText.textContent.trim()) || '';

    function updateCityDisplay() {
        const currentCity = cityHiddenInput.value;
        if (currentCity) {
            const selectedOption = document.querySelector(`[data-value="${currentCity}"]`);
            if (selectedOption) {
                const text = selectedOption.querySelector('.dropdown-item').textContent;
                cityDisplayText.textContent = text.length > 30 ? text.substring(0, 30) + '...' : text;
            }
        } else {
            cityDisplayText.textContent = defaultCityText;
        }
    }

    updateCityDisplay();

    cityToggle.addEventListener('click', function (e) {
        e.preventDefault();
        cityDropdown.classList.toggle('show');
    });

    // City option selection with auto-submit
    cityOptions.forEach(option => {
        option.addEventListener('click', function () {
            const value = this.getAttribute('data-value');
            cityHiddenInput.value = value;
            updateCityDisplay();
            cityDropdown.classList.remove('show');

        });
    });

    // City dropdown click prevention
    cityDropdown.addEventListener('click', function (e) {
        e.stopPropagation();
    });

    // Close city dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!cityToggle.contains(e.target) && !cityDropdown.contains(e.target)) {
            cityDropdown.classList.remove('show');
        }
    });
}

export function setupPropertyTypeFilter() {
    const propertyTypeToggle = document.querySelector('.property-type-dropdown-toggle');
    const propertyTypeDropdown = document.querySelector('.property-type-dropdown-menu');
    const propertyTypeHiddenInput = document.querySelector('#property-type-hidden-input');
    const propertyTypeDisplayText = document.querySelector('.property-type-display-text');
    const propertyTypeOptions = document.querySelectorAll('.property-type-option');

    if (!propertyTypeHiddenInput) return;

    const defaultPropertyTypeText = (propertyTypeDisplayText && propertyTypeDisplayText.textContent.trim()) || '';

    function updatePropertyTypeDisplay() {
        const currentPropertyType = propertyTypeHiddenInput.value;
        if (currentPropertyType) {
            const selectedOption = document.querySelector(`[data-value="${currentPropertyType}"]`);
            if (selectedOption) {
                const text = selectedOption.querySelector('.dropdown-item').textContent;
                propertyTypeDisplayText.textContent = text.length > 30 ? text.substring(0, 30) + '...' : text;
            }
        } else {
            propertyTypeDisplayText.textContent = defaultPropertyTypeText;
        }
    }

    updatePropertyTypeDisplay();

    propertyTypeToggle.addEventListener('click', function (e) {
        e.preventDefault();
        propertyTypeDropdown.classList.toggle('show');
    });

    // Property type option selection with auto-submit
    propertyTypeOptions.forEach(option => {
        option.addEventListener('click', function () {
            const value = this.getAttribute('data-value');
            propertyTypeHiddenInput.value = value;
            updatePropertyTypeDisplay();
            propertyTypeDropdown.classList.remove('show');

        });
    });

    // Property type dropdown click prevention
    propertyTypeDropdown.addEventListener('click', function (e) {
        e.stopPropagation();
    });

    // Close property type dropdown when clicking outside
    document.addEventListener('click', function (e) {
        if (!propertyTypeToggle.contains(e.target) && !propertyTypeDropdown.contains(e.target)) {
            propertyTypeDropdown.classList.remove('show');
        }
    });
}
